import moment from "moment";

// ----------------------------------------------------------------------

export const fDate = (date, newFormat) => {
  const fm = newFormat || "DD MMM yyyy";
  return date ? moment.utc(date).format(fm) : "";
};
